import React from "react";
import classNames from "classnames/bind";

import { LocationIcon } from "src/assets/icons";

import styles from "./SearchDestination.module.scss";
const cx = classNames.bind(styles);

const SearchDestination = () => {
  return (
    <div className={cx("search-destination-root")}>
      <div className={cx("box")}>
        <LocationIcon />
        <span>Discover New York</span>
      </div>
    </div>
  );
};

export default SearchDestination;
